import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import {
  IStoreBannersService,
  IStoreBannersListQuery,
} from "@shared/interfaces/store-banners-service.interface";
import { CampaignBannerDto } from "@shared/types/campaigns/campaign-banner.dto";
import {
  CreateStoreBannerDto,
  StoreBannerDto,
  UpdateStoreBannerDto,
} from "@shared/types/store-banner/store-banner.dto";

@appInjectable()
export class StoreBannersService
  extends BaseService
  implements IStoreBannersService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  create: IStoreBannersService["create"] = async (
    dto: CreateStoreBannerDto,
  ) => {
    const { data } = await this.httpClient.post<{
      data: { banner: StoreBannerDto };
    }>("/store-banners", dto, { baseURL: this.baseURL });
    return data.data.banner;
  };

  list: IStoreBannersService["list"] = async (
    query: IStoreBannersListQuery,
  ) => {
    const { data } = await this.httpClient.get<{
      data: {
        banners: StoreBannerDto[];
        total: number;
        campaigns: CampaignBannerDto[];
      };
    }>("/store-banners", {
      params: query,
      baseURL: this.baseURL,
    });
    return data.data;
  };

  get: IStoreBannersService["get"] = async (id: string) => {
    const { data } = await this.httpClient.get<{
      data: { banner: StoreBannerDto };
    }>(`/store-banners/${id}`, { baseURL: this.baseURL });
    return data.data.banner;
  };

  update: IStoreBannersService["update"] = async (
    dto: UpdateStoreBannerDto,
  ) => {
    const { data } = await this.httpClient.patch<{
      data: { banner: StoreBannerDto };
    }>(`/store-banners/${dto.id}`, dto, { baseURL: this.baseURL });
    return data.data.banner;
  };

  delete: IStoreBannersService["delete"] = async (id: string) => {
    await this.httpClient.delete(`/store-banners/${id}`, {
      baseURL: this.baseURL,
    });
  };
}
